"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseAction = void 0;
class BaseAction {
    constructor(params) {
        Object.assign(this, params);
    }
}
exports.BaseAction = BaseAction;
//# sourceMappingURL=base.action.js.map